<template>
  <div class="relative" data-test-id="article-card">
    <base-picture
      :alt="image.alt"
      class="w-full"
      fit="cover"
      height="380"
      :props-img="{ class: 'aspect-square' }"
      :src="image.src"
      width="380"
    />
    <div class="p-4 space-y-2">
      <p v-if="tags" class="line-clamp-1 flex gap-x-4 eyebrow <md:hidden">
        <span v-for="tag in tags" :key="tag" class="subtitle-6">
          {{ tag }}
        </span>
      </p>
      <p :id class="line-clamp-2 title-3">
        {{ title }}
      </p>
      <p v-if="description" class="body-4 line-clamp-2 <lg:hidden">
        {{ description }}
      </p>
      <base-link ref="linkRef" :aria-describedby="id" class="body-4 underlined i-block" :to>
        {{ $t.read }}
        <span class="absolute-0" />
      </base-link>
    </div>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  title: string
  to: string
  image: {
    src: string
    alt?: string
  }
  tags?: string[]
  date?: string
  description?: string
}>()

const id = useId()

const linkRef = useTemplateRef('linkRef')

const focus = () => {
  linkRef.value?.$el.focus({ preventScroll: true })
  linkRef.value?.$el.scrollIntoView({ behavior: 'smooth', block: 'start' })
}

defineExpose({ focus })
</script>
